module.exports = __webpack_public_path__ + "img/water01.c7215a84.png";